import React from 'react';
import { Page } from 'react-pdf';
const PageRenderer = ({ index, data, style }) => {
    const { handleScale, triggerResize } = data;
    const pageNumber = index + 1;
    return (React.createElement("div", Object.assign({}, { style }, { className: `page-${pageNumber}` }),
        React.createElement(Page, Object.assign({}, { pageNumber }, { scale: handleScale(pageNumber) }, { renderAnnotationLayer: false, onLoadError: (error) => console.error(error), onLoadSuccess: (page) => {
                triggerResize();
            } }))));
};
export default PageRenderer;
